import { render, staticRenderFns } from "./BaseDownloadAttachment.vue?vue&type=template&id=f043100c"
import script from "./BaseDownloadAttachment.vue?vue&type=script&lang=js"
export * from "./BaseDownloadAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports